export default __webpack_public_path__ + "static/media/Flag_of_San_Marino.b915692d.svg";